import useGoogleLogin from '@hooks/useGoogleLogin';
import { Box } from '@mui/material';
import { GoogleLogin } from '@react-oauth/google';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import useSession from '../hooks/useSession';
import { useUserAnalytics } from '../hooks/useUserAnalytics';
import { AUTH_EVENTS } from '../utils/eventSchema';

const GoogleSignIn = ({ fullWidth = true, sx = {} }) => {
  const navigate = useNavigate();
  const { trackEvent } = useUserAnalytics();
  const { setIsAuthenticated } = useSession();

  const { mutate: signInWithGoogle, isPending: isLoading } = useGoogleLogin();

  const handleGoogleSignInSuccess = (credentialResponse) => {
    signInWithGoogle(credentialResponse.credential, {
      onSuccess: (response) => {
        setIsAuthenticated(true);
        localStorage.setItem('jwtToken', response?.data.access_token);
        if (response?.data.is_onboarding === false) {
          navigate('/onboarding');
        } else {
          navigate('/');
        }
      },
    });
  };

  const handleGoogleSignInError = () => {
    console.error('Google Sign In Failed');
    toast.error('Google Sign In Failed. Please try again.');

    // Track failed login attempt
    trackEvent('auth', {
      ...AUTH_EVENTS.LOGIN_FAILED,
      error_message: 'Google OAuth error',
      login_method: 'google',
      attempt_time: new Date().toISOString(),
      device: navigator.userAgent,
    });
  };

  return (
    <Box sx={{ width: fullWidth ? '100%' : 'auto', ...sx }}>
      <GoogleLogin
        onSuccess={handleGoogleSignInSuccess}
        onError={handleGoogleSignInError}
        useOneTap={false}
        width={fullWidth ? '100%' : 'auto'}
        text="continue_with"
        shape="rectangular"
        theme="outline"
        size="large"
        type="standard"
        logo_alignment="left"
        disabled={isLoading}
      />
    </Box>
  );
};

export default GoogleSignIn;
